// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductSelectorStyles } from "@conklin/Overrides/Components/ProductSelector";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import siteMessage from "@insite/client-framework/SiteMessage";
import addProduct from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductSelector from "@insite/content-library/Components/ProductSelector";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    addProduct,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;

export interface QuickOrderSearchStyles {
    productSelector?: ProductSelectorStyles;
}

export const quickOrderSearchStyles: QuickOrderSearchStyles = {};

const styles = quickOrderSearchStyles;

const QuickOrderSearch = ({ addProduct }: Props) => {
    const toasterContext = useContext(ToasterContext);

    const addProductToOrder = (productInfo: ProductInfo, product: ProductModel) => {
        addProduct({ productInfo, product });
        toasterContext.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    return (
        <ProductSelector
            selectButtonTitle={translate("Add to Order")}
            onSelectProduct={addProductToOrder}
            productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
            productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
            extendedStyles={styles.productSelector}
            // XNG-Changes
            {...{ showUploadButton: true }}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(QuickOrderSearch),
    definition: {
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
